import React, { useEffect, useState, useMemo } from 'react'; // Added useMemo
import { useSelector } from 'react-redux'; // 1. Redux hook
import { List } from 'antd';
import makePins from './makePins';
import { getCityState, sameDay } from '../../utilities';
import moment from 'moment';

export default function Intakes({ directionsLibraries, selectedProject, setSelectedProject }) {
  // 2. Selectors
  const calendar = useSelector(state => state.calendar || {}); // Default to empty obj
  const map = useSelector(state => state.mapping?.map);
  const date = useSelector(state => state.date);

  const [pins, setPins] = useState({});
  
  const current = date ? date : moment();

  // 3. OPTIMIZATION: Use useMemo instead of useEffect for filtering.
  // This calculates the list *during* render, avoiding a double-render.
  const todayIntakes = useMemo(() => {
    return Object.values(calendar).filter((e) =>
      e?.date && sameDay(moment(e.date.toDate()).startOf('day'), current.startOf('day'))
    );
  }, [calendar, date]); // Dependencies: only re-calc if calendar or date changes

  // 4. Pin Effect
  // This stays as a useEffect because it interacts with the Google Maps API (Side effect)
  useEffect(
    function () {
      // Cleanup old pins
      for (let i in pins) {
        if (pins[i] && typeof pins[i].setMap === 'function') {
           pins[i].setMap(null);
        }
      }

      // Create new pins
      const p = makePins(todayIntakes, map);
      setPins(p);

      // Cleanup on unmount
      return () => {
        for (let i in p) {
           if (p[i] && typeof p[i].setMap === 'function') {
             p[i].setMap(null);
           }
        }
      };
    },
    [todayIntakes, map] // Run whenever the list changes or map instance loads
  );

  function selectProject(entry) {
    if (selectedProject.id === entry.data.id) {
      setSelectedProject({});
      const { directionsRenderer } = directionsLibraries || {};
      if (directionsRenderer) directionsRenderer.set('directions', null);
    } else {
      setSelectedProject(entry.data);
    }
  }

  return (
    <div>
      {todayIntakes.length > 0 && (
        <List
          dataSource={todayIntakes}
          renderItem={(entry) => {
            const { date, end } = entry;
            const [b, e] = [moment(date.toDate()), moment(end.toDate())];
            return (
              <div
                className="flex-row align-start pointer"
                style={{ fontSize: '75%' }}
                onClick={() => selectProject(entry)}
              >
                <div className="padding-right-1">
                  &#8226; {b.format('hh:mm A')} - {e.format('hh:mm A')}
                </div>
                <div className="padding-right-1">{getCityState(entry.data.site.geocode_results)}</div>
              </div>
            );
          }}
        />
      )}
    </div>
  );
}